import {SelectField} from './select-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {PillSelectFilter} from './pill-select-filter';
export class PillSelectField extends SelectField {
  getFilterInstance(): GridWidgetFilter {
    return new PillSelectFilter(this);
  }
}
